export const SHOW_LOAD = 'SHOW_LOAD';
export const HIDE_LOAD = 'HIDE_LOAD';
